import React from 'react';
import { useTable, usePagination } from 'react-table';
import { Container, Pagination, Containt } from './styles';

interface IColumns {
  Header: string,
  accessor: string
}
interface IProps {
  columns : IColumns[],
  data: any[]
}

const DashTable: React.FC<IProps> = ({ columns, data }) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
    },
    usePagination,
  );

  return (
    <Container>
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render('Header')}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => <td {...cell.getCellProps()}>{cell.render('Cell')}</td>)}
              </tr>
            );
          })}
        </tbody>
      </table>
      <Pagination>
        <Containt>
          <span>
            <strong>
              {pageIndex + 1} / {pageOptions.length}
            </strong>{' '}
          </span>
          <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}> {'<<'} </button> {' '}
          <button onClick={() => previousPage()} disabled={!canPreviousPage}> {'<'} </button> {' '}
          <button onClick={() => nextPage()} disabled={!canNextPage}> {'>'} </button>{' '}
          <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}> {'>>'} </button> {' '}
          <select
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));
            }}
          >
            {[10, 20, 30, 40, 50].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                Mostrar {pageSize}
              </option>
            ))}
          </select>
        </Containt>
      </Pagination>
    </Container>
  );
};

export default DashTable;
